import { Grid } from "@mui/material";
import { observer } from "mobx-react";
import React, { FunctionComponent } from "react";
import { useStore } from "../../../../utils/useStore";
import AcxDataGrid from "../../../UI/AcxDataGrid/AcxDataGrid";
import { AgentCoachingStore } from "../Stores/AgentCoachingStore";

const AgentManagersCoachingTable: FunctionComponent = observer(() => {
    const store = useStore(AgentCoachingStore);

    return (
        <Grid container item xs={12} height={"49vh"}>
            <AcxDataGrid dataGridStore={store.managerDgStore} />
        </Grid>
    );
});

export default AgentManagersCoachingTable;
